export default function ProblemSolution() {
  const problems = [
    {
      icon: 'ri-building-line',
      title: '離れて暮らしていて、',
      subtitle: '実家に帰る時間がない...',
      description: '仕事や家庭で手一杯。実家の整理は後回しになってしまう。',
      agitation: '放置してしまうと、ご両親の負担が増えるだけでなく、いざという時にさらなる苦労を招く原因に…'
    },
    {
      icon: 'fas fa-couch',
      title: '重い大型家具、',
      subtitle: 'どう処分すればいいか分からない…',
      description: '重い桐箪笥や仏壇、大きな食器棚。運び出すのも一苦労。',
      agitation: '自治体の粗大ゴミは運び出しが大変で、費用もかさみます。何から手をつければいいのか…'
    },
    {
      icon: 'ri-question-line',
      title: '骨董品や着物、',
      subtitle: '価値がわからず捨てるのが不安…',
      description: '祖父母の遺品、もしかしたら価値があるかも？でも判断できない。',
      agitation: '大切な思い出の品を無下にはできない。でも、どこに相談すれば適正に評価してもらえるのか…'
    },
    {
      icon: 'ri-map-pin-line',
      title: '遠方からの片付け、',
      subtitle: '何から始めればいいか不安…',
      description: '実家は地方、自分は都心。限られた帰省時間で全部は無理。',
      agitation: '一人で抱え込まずに、プロに任せるという選択肢を検討してみませんか？'
    }
  ];

  return (
    <section className="py-24 bg-[#FAF6F0]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-[#3E2723] mb-6 font-serif">
            こんなお悩み、ありませんか？
          </h2>
          <p className="text-xl text-gray-700 leading-relaxed">
            実家の片付けは、誰にとっても大きな悩みです。<br />
            <span className="text-[#00A58E] font-semibold">決して、あなた一人だけではありません。</span>
          </p>
        </div>

        {/* Problems Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          {problems.map((problem, index) => (
            <div 
              key={index} 
              className="bg-white rounded-2xl p-8 shadow-md hover:shadow-xl transition-all border border-gray-100"
            >
              {/* Icon */}
              <div className="w-20 h-20 flex items-center justify-center bg-[#FFE8E0] rounded-full mb-6">
                <i className={`${problem.icon} text-4xl text-[#FF6B35]`}></i>
              </div>

              {/* Title */}
              <h3 className="text-2xl font-bold text-gray-800 mb-2 font-serif">
                {problem.title}
              </h3>
              <p className="text-xl font-semibold text-gray-700 mb-4">
                {problem.subtitle}
              </p>

              {/* Description */}
              <p className="text-base text-gray-600 leading-relaxed mb-4">
                {problem.description}
              </p>

              {/* Agitation */}
              <div className="bg-[#FFF3E0] border-l-4 border-[#FF6B35] p-4 rounded">
                <p className="text-sm text-gray-700 leading-relaxed">
                  <i className="ri-alert-line text-[#FF6B35] mr-2"></i>
                  {problem.agitation}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Empathy Message */}
        <div className="bg-gradient-to-r from-[#00A58E] to-[#008C7A] rounded-2xl p-10 text-center shadow-xl">
          <p className="text-white text-3xl font-bold mb-4 font-serif">
            <i className="ri-heart-line mr-3"></i>
            そのお悩み、買取かわせみが解決いたします
          </p>
          <p className="text-white/90 text-lg leading-relaxed max-w-3xl mx-auto">
            業界歴10年のベテラン鑑定士・吉田が、真心込めて丁寧に対応いたします。<br />
            遠方からのご依頼も、まずはお気軽にご相談ください。
          </p>
        </div>
      </div>
    </section>
  );
}